export default {"src":"/_next/static/media/card.0bdbe1cf.svg","height":19,"width":24,"blurWidth":0,"blurHeight":0};